"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryReportUserFeedback = exports.SentryReportCustomError = exports.SentryReportNetworkingParseException = exports.SentryReportNetworkingXHRTimeout = exports.SentryReportNetworkingXHR = exports.SentryReportFileAttachment = exports.SentryInit = void 0;
const Sentry = require("@sentry/browser");
const DOM_1 = require("../DOM");
const Notify_1 = require("../Notify");
const SentryUtil_1 = require("./SentryUtil");
const Toggles_1 = require("../Toggles");
const SentryInit = () => {
    if (!Toggles_1.Toggles.Handler.toggleAvailable('SENTRY')) {
        return;
    }
    const sentrySessionClient = (0, SentryUtil_1.SentryUtilGetClient)();
    const sentryEnv = (0, SentryUtil_1.SentryUtilGetEnvironment)();
    Sentry.init({
        dsn: sentryEnv === 5
            ? "https://8fd3ba36d98bbef5b9a2430e2985473c@o381139.ingest.sentry.io/4506677631385600"
            : "https://f7f47fdb3493caed396934d08506b23b@o381139.ingest.sentry.io/4506666009755648",
        release: DOM_1.DOM.Parser.getDataByNameFromElement('release', DOM_1.DOM.Parser.getBodyElement()),
        environment: sentryEnv === 5 ? 'production' : 'sentryTest',
        initialScope: {
            user: { id: sentrySessionClient ? sentrySessionClient.id : undefined },
            extra: { sessionClient: sentrySessionClient }
        },
        integrations: [
            Sentry.browserTracingIntegration({}),
            Sentry.browserProfilingIntegration(),
            Sentry.replayIntegration({
                blockAllMedia: true,
                unmask: ['.sentry-unmask, [data-sentry-unmask]'],
                networkDetailAllowUrls: [window.location.origin],
                networkRequestHeaders: ['X-Custom-Header'],
                networkResponseHeaders: ['X-Custom-Header'],
            }),
        ],
        tracesSampleRate: sentryEnv === 5 ? 0.2 : 1,
        profilesSampleRate: sentryEnv === 5 ? 0.5 : 1,
        replaysSessionSampleRate: sentryEnv === 5 ? 0.01 : 1,
        replaysOnErrorSampleRate: sentryEnv === 5 ? 1.0 : 1,
        beforeSend: async (event, hint) => {
            if (window.location.pathname.includes('tickets.tickets')) {
                if (document.getElementById('ticketReplyForm')) {
                    hint.attachments = await (0, exports.SentryReportFileAttachment)(DOM_1.DOM.Parser.getHtmlElement('ticketReplyForm'), 'attachment') ?? undefined;
                }
            }
            return event;
        },
    });
};
exports.SentryInit = SentryInit;
const SentryReportFileAttachment = (formElement, inputName) => {
    return new Promise((resolve) => {
        const file = (new FormData(formElement)).get(inputName);
        if (file.size === 0) {
            resolve(null);
        }
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.result) {
                const arrayBuffer = reader.result;
                const array = new Uint8Array(arrayBuffer);
                resolve([{
                        filename: file.name,
                        contentType: file.type,
                        attachmentType: "event.attachment",
                        data: array
                    }]);
            }
        };
        reader.readAsArrayBuffer(file);
    });
};
exports.SentryReportFileAttachment = SentryReportFileAttachment;
const SentryReportNetworkingXHR = (xhr, requestParameters) => {
    const urlClean = (0, SentryUtil_1.SentryUtilCleanURI)(requestParameters.url);
    const statusText = xhr.statusText.trim().length > 0 ? xhr.statusText : xhr.status;
    const sentryId = Sentry.captureMessage(`[NET-XHR]: ${statusText} - ${requestParameters.type}/${urlClean}`, { extra: {
            statusText: xhr.statusText,
            status: xhr.status,
            readyState: xhr.readyState,
            requestParameters: requestParameters,
            responseType: xhr.responseType,
            response: xhr.responseText,
            timeout: xhr.timeout,
        } });
    Notify_1.Notify.Handler.showServerError(sentryId, ['JS', 'INT', 'NET', 'XHR', statusText.toString()]);
    console.error(`[NET-XHR]: ${statusText} - ${requestParameters.type}/${urlClean}`);
};
exports.SentryReportNetworkingXHR = SentryReportNetworkingXHR;
const SentryReportNetworkingXHRTimeout = (xhr, requestParameters) => {
    const urlClean = (0, SentryUtil_1.SentryUtilCleanURI)(requestParameters.url);
    const sentryId = Sentry.captureMessage(`[NET-XHR-TIMEOUT]: Timeout - ${requestParameters.type}/${urlClean}`, { extra: { response: xhr.responseText, status: xhr.statusText, url: requestParameters.url } });
    Notify_1.Notify.Handler.showServerError(sentryId, ['JS', 'INT', 'NET', 'XHR', 'TIMEOUT']);
    console.error(`[NET-XHR-TIMEOUT]: Timeout - ${requestParameters.type}/${urlClean}`);
};
exports.SentryReportNetworkingXHRTimeout = SentryReportNetworkingXHRTimeout;
const SentryReportNetworkingParseException = (xhr, e, requestParameters) => {
    const sentryId = Sentry.captureException(e, { extra: { response: xhr.responseText, status: xhr.statusText, url: requestParameters.url } });
    Notify_1.Notify.Handler.showServerError(sentryId, ['JS', 'INT', 'NET', 'PRS']);
    console.error(`[NET-PRS]: ${e.message.replace(/(\r\n|\n|\r)/gm, "")}`, e);
};
exports.SentryReportNetworkingParseException = SentryReportNetworkingParseException;
const SentryReportCustomError = (msg, extra) => {
    Sentry.captureMessage(msg, { extra: extra ? { ...{ url: window.location.href }, ...extra } : { url: window.location.href } });
    console.error(msg, extra);
};
exports.SentryReportCustomError = SentryReportCustomError;
const SentryReportUserFeedback = (message, sentryEventId) => {
    const sentrySessionClient = (0, SentryUtil_1.SentryUtilGetClient)();
    const eventId = sentryEventId ?? Sentry.captureMessage("User Feedback");
    Sentry.captureFeedback({
        associatedEventId: eventId,
        name: sentrySessionClient?.name ?? 'Anonymous user',
        email: sentrySessionClient?.email ?? 'anonymous@master.cz',
        message: message,
        url: window.location.href
    });
    return eventId;
};
exports.SentryReportUserFeedback = SentryReportUserFeedback;
